import { FC } from 'react';
import { ListPost } from 'types/PostDetail';
import ApprovalPostCard from './ApprovalPostCard';
import { usePostVisibility } from '../hooks/usePostVisibility';
import ApprovalCommunicationPanel from './ApprovalPostCommunication/ApprovalCommunicationPanel';
import { useApprovedPosts } from '../context/ApprovedPostsContext';
import { STATUS } from '@kontentino/kontentino-constants/Posts';

type Props = {
  post: ListPost;
};

const ApprovalPostItem: FC<Props> = ({ post }) => {
  const [ref, isVisible] = usePostVisibility({
    threshold: 0.1,
    rootMargin: '200px',
  });
  const { addApprovedPost } = useApprovedPosts();

  const handleApprovalPageSuccess = () => {
    const thread: 'internal' | 'client' =
      post.status === STATUS.WAITING_FOR_INTERNAL_APPROVAL
        ? 'internal'
        : 'client';

    addApprovedPost({
      id: post.id,
      title: post.text || '',
      thumbnail: post.preview_image?.src ?? null,
      previousStatus: post.status,
      thread,
      pageId: post.page.id,
      pageType: post.page.type,
    });
  };

  return (
    <div
      ref={ref}
      className="tw-flex tw-min-h-[400px] tw-flex-col tw-items-start tw-gap-3 md:tw-flex-row "
      data-cy="approvals_post-item_container"
      data-name="approvals_post-item_container"
    >
      <ApprovalPostCard post={post} />
      <ApprovalCommunicationPanel
        post={post}
        isVisible={isVisible}
        onApprovalPageSuccess={handleApprovalPageSuccess}
      />
    </div>
  );
};

export default ApprovalPostItem;
